export type ChatsViewTranslation = {
  composer: {
    hint: string;
    placeholder: string;
    placeholderIn: string;
    send: string;
    tooLong: string;
  };
  conversation: {
    announcementsHint: string;
    emptyHint: string;
    emptyTitle: string;
    jumpToLatest: string;
    loadOlder: string;
    noChatSelected: string;
    notificationsHint: string;
    sending: string;
    unread: string;
  };
  header: {
    announcementsSubtitle: string;
    back: string;
    notificationsSubtitle: string;
    onlyYou: string;
    participants: PluralForms;
  };
  list: {
    clearSearch: string;
    emptyHint: string;
    emptyTitle: string;
    noMessages: string;
    noResults: string;
    notifications: string;
    search: string;
    title: string;
    unread: PluralForms;
    you: string;
  };
  participants: {
    noResults: string;
    nothingRead: string;
    readUpTo: string;
    search: string;
    title: string;
    upToDate: string;
    you: string;
  };
  receipts: {
    read: string;
    readBy: string;
    readByAll: string;
    readBySome: string;
    seenBy: string;
    seenByUndated: string;
    sent: string;
    waitingFor: string;
  };
};

type PluralForms = {
  few: string;
  many: string;
  one: string;
};

export const chatsViewTranslation: ChatsViewTranslation = {
  composer: {
    hint: 'Enter wysyła, Shift + Enter dodaje nową linię',
    placeholder: 'Napisz wiadomość…',
    placeholderIn: 'Napisz do: {{name}}',
    send: 'Wyślij',
    tooLong: 'Wiadomość jest za długa — skróć ją o {{count}} zn.',
  },
  conversation: {
    announcementsHint:
      'Ogłoszenia trafiają do wszystkich aktywnych użytkowników. Piszą je osoby z uprawnieniem „Pisanie ogłoszeń do wszystkich”.',
    emptyHint: 'Napisz pierwszą wiadomość — zobaczą ją wszyscy uczestnicy.',
    emptyTitle: 'Tu jeszcze cisza',
    jumpToLatest: 'Nowe wiadomości',
    loadOlder: 'Wczytaj starsze wiadomości',
    noChatSelected: 'Wybierz rozmowę z listy',
    notificationsHint:
      'Tu trafiają automatyczne powiadomienia, np. o przypisaniu procesu. Na powiadomienia się nie odpowiada.',
    sending: 'Wysyłanie…',
    unread: 'Nowe wiadomości',
  },
  header: {
    announcementsSubtitle: 'Wszyscy aktywni użytkownicy',
    back: 'Wróć do listy rozmów',
    notificationsSubtitle: 'Powiadomienia systemowe',
    onlyYou: 'Tylko Ty',
    participants: {
      few: '{{count}} uczestników',
      many: '{{count}} uczestników',
      one: '1 uczestnik',
    },
  },
  list: {
    clearSearch: 'Wyczyść',
    emptyHint: 'Gdy ktoś doda Cię do czatu, rozmowa pojawi się tutaj.',
    emptyTitle: 'Nie masz jeszcze żadnych rozmów',
    noMessages: 'Brak wiadomości',
    noResults: 'Żadna rozmowa nie pasuje do wyszukiwania',
    notifications: 'Powiadomienia',
    search: 'Szukaj rozmowy lub osoby',
    title: 'Czaty',
    unread: {
      few: '{{count}} nieprzeczytane',
      many: '{{count}} nieprzeczytanych',
      one: '1 nieprzeczytana',
    },
    you: 'Ty',
  },
  participants: {
    noResults: 'Nikt nie pasuje',
    nothingRead: 'Nic jeszcze nie przeczytane',
    readUpTo: 'Przeczytane do: {{date}}',
    search: 'Szukaj osoby',
    title: 'Uczestnicy',
    upToDate: 'Na bieżąco',
    you: 'Ty',
  },
  receipts: {
    read: 'Przeczytane',
    readBy: 'Przeczytane przez',
    readByAll: 'Przeczytane przez wszystkich',
    readBySome: 'Przeczytane przez {{count}} z {{total}}',
    seenBy: '{{name}} · przeczytane do tego miejsca · {{date}}',
    seenByUndated: '{{name}} · przeczytane do tego miejsca',
    sent: 'Wysłane',
    waitingFor: 'Czeka na',
  },
};
